import IJitRepository from '../domain/IJitRepository';
import jitRepository from '../infrastructure/repositories/JitRepository';

class DeleteJitRemarksByIdService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute({ queryParams }: { queryParams: { id: number } }) {
    return this._jitRepository.deleteJitRemarksById({ queryParams });
  }
}

export default new DeleteJitRemarksByIdService({
  repository: jitRepository
});

export { DeleteJitRemarksByIdService };
